// removed by extract-text-webpack-plugin
module.exports = {"brand":"#2f75c1","koala":"#c5c7cb","spacing-medium":"8px","spacing-large":"16px","this":"MessageStarterItem__this___61zXL","reachability":"MessageStarterItem__reachability___1Y0hX"};


//////////////////
// WEBPACK FOOTER
// ./src/chat/components/styles/MessageStarterItem.css
// module id = 1875
// module chunks = 4